(function () {
  "use strict";

  angular
    .module("app.microsite", [
      "app.common",
      "app.forms",
      "modules.dataServices",
      "youtube-embed",
      "modules.snapshotRange",
      "ngSanitize",
      "angular-inview",
      "slickCarousel",
      "ngLocationUpdate",
      "ngRoute",
      "modules.device",
      "modules.priceStartingAt",
      "ngTouch",
      "app.login",
      "app.saved",
      "modules.authServices"
    ])

    .config([
      "$interpolateProvider",
      function ($interpolateProvider) {
        $interpolateProvider.startSymbol("<%");
        $interpolateProvider.endSymbol("%>");
      },
    ])

    .config([
      "$locationProvider",
      function ($locationProvider) {
        $locationProvider.html5Mode({
          enabled: false,
          requireBase: true,
          rewriteLinks: false,
        });
      },
    ]);
})();
